import { useCallback, useEffect, useRef } from "react";

import { useVolatileCallback } from "./useVolatile";

export const useInterval = (callback: any, delay: number | null) => {
  const savedCallback = useRef<any>(null);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback?.current();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};

// useInterval, but it allows you to reset the interval by calling a function
export const useRefreshableInterval = (
  callback: () => void,
  delay: number,
): [refreshInterval: () => void] => {
  const stableCallback = useVolatileCallback(callback);
  const intervalId = useRef<NodeJS.Timeout | null>(null);

  const refreshInterval = useCallback(() => {
    if (intervalId.current) {
      clearInterval(intervalId.current);
    }
    intervalId.current = setInterval(() => {
      stableCallback();
    }, delay);
  }, [delay, stableCallback]);

  useEffect(() => {
    refreshInterval();

    return () => {
      if (intervalId.current) {
        clearInterval(intervalId.current);
      }
    };
  }, [refreshInterval]);

  return [refreshInterval];
};
